import React, { Component } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
// components
import { Menu } from '../../../../components/modules/user/menu';
// middlewares
import MenuMiddleware from '../../../../middleware/modules/user/menu';
import i18n from '../../../../i18n';
import { Helmet } from 'react-helmet';

const mapStateToProps = ({ auth,menu }) => ({
  isProcessing: menu.isProcessing,
  isError: auth.isError,
  errorMessage: auth.errorMessage,
  datalist:menu.data,
  showModal:menu.showModal
});

const mapDispatchToProps = (dispatch) => {
  return bindActionCreators({
    reset: () =>MenuMiddleware.resetList(),
    create: (search) =>MenuMiddleware.create(search),
    search: data =>MenuMiddleware.list(data),
    update: data =>MenuMiddleware.update(data),
    delete: (id,search) =>MenuMiddleware.beforeDelete(id,search),
    //helpers
    getHelper: () =>MenuMiddleware.getHelperFull(),
   
  }, dispatch);
};
class MenuContainer extends Component {
  
  static propTypes = {
    isAuthenticated: PropTypes.bool,
    isProcessing: PropTypes.bool,
    isRegistered: PropTypes.bool,
    isError: PropTypes.bool,
    errorMessage: PropTypes.any,
    datalist: PropTypes.object,
    search: PropTypes.func.isRequired
  }

  static defaultProps = {
    isAuthenticated: false,
    isProcessing: false,
    isRegistered: false,
    isError: false,
    errorMessage: [],
  }

  constructor(props){
    super(props)
    this.deleteItem=this.deleteItem.bind(this);
    this.createItem=this.createItem.bind(this);
    this.updateItem=this.updateItem.bind(this);
  }

  componentWillMount() {
    const search = {
      limit: 10,
    };
   this.props.reset();
   this.props.search(search);
  }

  deleteItem(id,search){
    this.props.delete(id,search)
  }
  updateItem(id){
    this.props.update(id)
    this.props.getHelper()
  }
  createItem(search=null){
    this.props.create(search)
  }
  render() {
    const {isProcessing, search , datalist,showModal} = this.props;
    return (
      <React.Fragment>
        <Helmet>
          <title>
            {i18n.t("Menu List")}
          </title>
        </Helmet>
      <Menu
        search={search}
        data={datalist}
        isProcessing={isProcessing}
        showModal={showModal}
        deleteItem={this.deleteItem}
        updateItem={this.updateItem}
        createData={this.createItem}
      />
      </React.Fragment>
    );
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(MenuContainer);
